import { CREATE_VALET, UPDATE_VALET_STATUS, TAG_CREATION, TAG_LIST } from "./type";

const initalState = {
    valetRes: null,
    updateValetStatus: {},
    tagCreation:[],
    tagListing:[]
};

const CreateValet = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case CREATE_VALET:
            return {
                ...state,
                valetRes: payload,
            };
        case UPDATE_VALET_STATUS:
            return {
                ...state,
                updateValetStatus: payload,
            };
        case TAG_CREATION:
            return {
                ...state,
                tagCreation: payload,
            };
        case TAG_LIST:
            return {
                ...state,
                tagListing: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default CreateValet;
